/* assets/provider-approval-status.js — GCITYPARTNERS-PROVIDER-APPROVAL-04
 * Projects provider_approvals and owns the explicit Apply as Provider submission.
 * Application may create pending state only; it never grants Provider authority or sets approval decisions.
 */
(function (window, document) {
  'use strict';
  var KEY = '__GCITYPARTNERS_PROVIDER_APPROVAL_STATUS__';
  var PROFILE_ROOT = '[data-provider-profile]';
  var DENIED_ROOT = '[data-provider-portal-access="denied"]';
  var DASHBOARD_ROOT = '[data-provider-status-panel]';
  var STATUS_ENDPOINT = 'https://api.glhksolution.com/v1/gcitypartners/provider/status';
  var APPLY_ENDPOINT = 'https://api.glhksolution.com/v1/gcitypartners/provider/apply';
  var API_ORIGIN = 'https://api.glhksolution.com';
  var mounted = new WeakSet();

  if (window[KEY] && typeof window[KEY].refresh === 'function') {
    window[KEY].refresh(document);
    return;
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }
  function isZh() {
    return /^zh/i.test(clean(document.documentElement.lang));
  }
  function words(zh, en) {
    return isZh() ? zh : en;
  }
  function approvalLabel(state) {
    switch (state) {
      case 'not_applied':
        return words('尚未提交申請', 'Application not submitted');
      case 'pending':
        return words('申請審核中', 'Application under review');
      case 'approved':
        return words('已核准 Provider', 'Approved Provider');
      case 'rejected':
        return words('申請未獲批准', 'Application not approved');
      case 'suspended':
        return words('Provider 權限已暫停', 'Provider access suspended');
      default:
        return words('狀態暫不可用', 'Status unavailable');
    }
  }
  function nativeSession() {
    var value = window.LittleGWebSession;
    return value && typeof value.authenticatedFetch === 'function' ? value : null;
  }
  function trustedEndpoint(raw, expectedPath) {
    try {
      var url = new URL(raw, API_ORIGIN);
      return url.origin === API_ORIGIN && url.pathname === expectedPath ? url.toString() : '';
    } catch (_error) {
      return '';
    }
  }
  function statusEndpoint() {
    return trustedEndpoint(STATUS_ENDPOINT, '/v1/gcitypartners/provider/status');
  }
  function applyEndpoint() {
    return trustedEndpoint(APPLY_ENDPOINT, '/v1/gcitypartners/provider/apply');
  }
  function ensureDeniedProjection(root) {
    var badge = root.querySelector('[data-provider-approval-readonly]');
    if (!badge) {
      badge = document.createElement('p');
      badge.setAttribute('data-provider-approval-readonly', '');
      badge.setAttribute('role', 'status');
      badge.setAttribute('aria-live', 'polite');
      root.appendChild(badge);
    }
    var note = root.querySelector('[data-provider-approval-note]');
    if (!note) {
      note = document.createElement('p');
      note.setAttribute('data-provider-approval-note', '');
      note.hidden = true;
      root.appendChild(note);
    }
    var apply = root.querySelector('[data-provider-apply]');
    if (!apply) {
      apply = document.createElement('button');
      apply.type = 'button';
      apply.className = 'portal-button portal-button--primary';
      apply.setAttribute('data-provider-apply', '');
      apply.hidden = true;
      apply.style.marginTop = '16px';
      apply.style.marginRight = '8px';
      var logout = root.querySelector('[data-provider-native-logout]');
      root.insertBefore(apply, logout || null);
    }
    return {
      badge: badge,
      note: note,
      apply: apply,
      workspace: null,
      title: root.querySelector('h1'),
      description: root.querySelector('h1 + p'),
      dashboard: false,
    };
  }
  function projectionNodes(root) {
    if (root.matches && root.matches(DENIED_ROOT)) return ensureDeniedProjection(root);
    if (root.matches && root.matches(DASHBOARD_ROOT)) {
      return {
        badge: root.querySelector('[data-provider-status-label]'),
        note: root.querySelector('[data-provider-approval-note]'),
        apply: root.querySelector('[data-provider-apply]'),
        workspace: root.querySelector('[data-provider-workspace-entry]'),
        title: null,
        description: null,
        dashboard: true,
      };
    }
    return {
      badge: root.querySelector('[data-provider-profile-approval]'),
      note: root.querySelector('[data-provider-approval-note]'),
      apply: null,
      workspace: null,
      title: null,
      description: null,
      dashboard: false,
    };
  }
  function renderDeniedState(nodes, state) {
    if (!nodes.title || !nodes.description) return;
    switch (state) {
      case 'not_applied':
        nodes.title.textContent = words('申請成為服務合作夥伴', 'Apply as a Provider');
        nodes.description.textContent = words(
          '你已登入 GCityPartners。提交 Provider 申請後會進入審核；提交申請不會自動取得 Provider 權限。',
          'You are signed in to GCityPartners. Submit a Provider application for review. Applying does not grant Provider access.'
        );
        break;
      case 'pending':
        nodes.title.textContent = words('Provider 申請審核中', 'Provider application under review');
        nodes.description.textContent = words(
          '申請已提交。審批完成前仍不能接單、報價或使用 Provider 工作流程。',
          'Your application has been submitted. Provider work, quoting and delivery remain locked until approval.'
        );
        break;
      case 'rejected':
        nodes.title.textContent = words(
          'Provider 申請未獲批准',
          'Provider application not approved'
        );
        nodes.description.textContent = words(
          'Provider 權限仍然關閉。如需重新申請，請聯絡 GLG。',
          'Provider access remains closed. Contact GLG if you need to reapply.'
        );
        break;
      case 'suspended':
        nodes.title.textContent = words('Provider 權限已暫停', 'Provider access suspended');
        nodes.description.textContent = words(
          '此 Provider 權限目前已暫停；請聯絡 GLG 了解審批狀態。',
          'This Provider role is currently suspended. Contact GLG for the approval status.'
        );
        break;
      case 'approved':
        nodes.title.textContent = words('Provider 已獲核准', 'Provider approved');
        nodes.description.textContent = words(
          'Provider approval 已確認；工作區權限會由後端重新核實。',
          'Provider approval is confirmed. Workspace access will be revalidated by the backend.'
        );
        break;
      default:
        nodes.title.textContent = words('Provider 狀態暫不可用', 'Provider status unavailable');
        nodes.description.textContent = words('請稍後重新整理。', 'Refresh and try again later.');
    }
  }
  function render(root, nodes, state, approval) {
    root.setAttribute('data-provider-approval-state', state);
    if (nodes.badge) {
      nodes.badge.textContent =
        (nodes.dashboard ? words('Provider：', 'Provider: ') : words('審批：', 'Approval: ')) +
        approvalLabel(state);
    }
    if (nodes.note) {
      nodes.note.textContent =
        approval && clean(approval.decision_note)
          ? words('審批意見：', 'Decision note: ') + clean(approval.decision_note)
          : '';
      nodes.note.hidden = !nodes.note.textContent;
    }
    if (nodes.apply) {
      nodes.apply.textContent = words('申請成為服務合作夥伴', 'Apply as a Provider');
      nodes.apply.hidden = state !== 'not_applied';
      nodes.apply.disabled = false;
    }
    if (nodes.workspace) nodes.workspace.hidden = state !== 'approved';
    if (root.matches && root.matches(DENIED_ROOT)) renderDeniedState(nodes, state);
  }
  async function submitApplication(root, button) {
    var session = nativeSession();
    var url = applyEndpoint();
    var nodes = projectionNodes(root);
    if (!session || !url) {
      if (nodes.badge)
        nodes.badge.textContent = words('申請服務暫不可用', 'Application service unavailable');
      return;
    }
    var initialSession = session.getState && session.getState();
    var currentSubject = clean(
      initialSession && initialSession.profile && initialSession.profile.id
    );
    if (!initialSession || initialSession.status !== 'authenticated' || !currentSubject) {
      button.disabled = true;
      return;
    }
    button.disabled = true;
    if (nodes.badge)
      nodes.badge.textContent = words(
        '正在提交 Provider 申請…',
        'Submitting Provider application…'
      );
    try {
      var response = await session.authenticatedFetch(url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });
      var payload = await response.json().catch(function () {
        return {};
      });
      var latestSession = session.getState && session.getState();
      if (
        !root.isConnected ||
        !latestSession ||
        latestSession.status !== 'authenticated' ||
        clean(latestSession.profile && latestSession.profile.id) !== currentSubject
      )
        return;
      if (!response.ok || !payload || payload.ok !== true) {
        throw new Error(clean(payload && payload.error) || 'provider_application_failed');
      }
      await load(root);
    } catch (_error) {
      var latestSession = session.getState && session.getState();
      if (
        !root.isConnected ||
        !latestSession ||
        latestSession.status !== 'authenticated' ||
        clean(latestSession.profile && latestSession.profile.id) !== currentSubject
      )
        return;
      if (nodes.badge)
        nodes.badge.textContent = words(
          '申請暫時未能提交，請稍後再試。',
          'Application could not be submitted. Try again later.'
        );
      button.disabled = false;
    }
  }
  function bindApply(root, button) {
    if (!button || button.getAttribute('data-provider-apply-bound') === 'true') return;
    button.setAttribute('data-provider-apply-bound', 'true');
    button.addEventListener('click', function () {
      void submitApplication(root, button);
    });
  }
  async function load(root) {
    var nodes = projectionNodes(root);
    var badge = nodes.badge;
    if (!badge) return;
    bindApply(root, nodes.apply);
    var session = nativeSession();
    var url = statusEndpoint();
    if (!session || !url) {
      badge.textContent = nodes.dashboard
        ? words('Provider：需登入', 'Provider: sign-in required')
        : words('審批：需登入', 'Approval: sign-in required');
      if (nodes.note) {
        nodes.note.textContent = '';
        nodes.note.hidden = true;
      }
      if (nodes.apply) nodes.apply.hidden = true;
      if (nodes.workspace) nodes.workspace.hidden = true;
      return;
    }
    var currentSession = session.getState && session.getState();
    var currentSubject = clean(
      currentSession && currentSession.profile && currentSession.profile.id
    );
    if (!currentSession || currentSession.status !== 'authenticated' || !currentSubject) {
      if (nodes.note) {
        nodes.note.textContent = '';
        nodes.note.hidden = true;
      }
      if (nodes.apply) nodes.apply.hidden = true;
      if (nodes.workspace) nodes.workspace.hidden = true;
      badge.textContent = nodes.dashboard
        ? words('Provider：需登入', 'Provider: sign-in required')
        : words('審批：需登入', 'Approval: sign-in required');
      return;
    }
    if (nodes.workspace) nodes.workspace.hidden = true;
    if (nodes.apply) nodes.apply.hidden = true;
    try {
      var response = await session.authenticatedFetch(url, {
        headers: { Accept: 'application/json' },
      });
      var payload = await response.json().catch(function () {
        return {};
      });
      var latestSession = session.getState && session.getState();
      if (
        !root.isConnected ||
        !latestSession ||
        latestSession.status !== 'authenticated' ||
        clean(latestSession.profile && latestSession.profile.id) !== currentSubject
      )
        return;
      if (!response.ok || !payload || payload.ok !== true)
        throw new Error(clean(payload && payload.error) || 'approval_status_unavailable');
      var approval =
        payload.approval && typeof payload.approval === 'object' ? payload.approval : null;
      var state = approval ? clean(approval.status || 'unknown') : 'not_applied';
      render(root, nodes, state, approval);
    } catch (_error) {
      var latestSession = session.getState && session.getState();
      if (
        !root.isConnected ||
        !latestSession ||
        latestSession.status !== 'authenticated' ||
        clean(latestSession.profile && latestSession.profile.id) !== currentSubject
      )
        return;
      badge.textContent = nodes.dashboard
        ? words('Provider：暫不可用', 'Provider: unavailable')
        : words('審批：暫不可用', 'Approval: unavailable');
      if (nodes.note) {
        nodes.note.textContent = '';
        nodes.note.hidden = true;
      }
      if (nodes.apply) nodes.apply.hidden = true;
      if (nodes.workspace) nodes.workspace.hidden = true;
    }
  }
  function mount(root) {
    if (!root || mounted.has(root)) return;
    mounted.add(root);
    void load(root);
  }
  function roots(scope) {
    var context = scope || document;
    var output = [];
    Array.prototype.push.apply(output, context.querySelectorAll(PROFILE_ROOT));
    Array.prototype.push.apply(output, context.querySelectorAll(DENIED_ROOT));
    Array.prototype.push.apply(output, context.querySelectorAll(DASHBOARD_ROOT));
    return output;
  }
  function refresh(scope) {
    roots(scope).forEach(function (root) {
      if (mounted.has(root)) void load(root);
      else mount(root);
    });
  }
  window[KEY] = Object.freeze({ refresh: refresh });
  document.addEventListener('littleg:web-session-change', function () {
    refresh(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target || document);
  });
  if (document.readyState === 'loading')
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        refresh(document);
      },
      { once: true }
    );
  else refresh(document);
})(window, document);
